import styled, { css } from 'styled-components'

const lstPxs = [115, 290, 170, 260, 170, 170, 170, 170, 500, 170, 170]
const gridArr = lstPxs.map((item) =>
    typeof item === 'number' ? `${item}px` : item
)

const extendStylesTable = css`
    .header,
    .row {
        grid-template-columns: ${gridArr.join(' ')};
    }
`
const extendStylesTeller = css`
    width: 220px;
`

export { extendStylesTable, extendStylesTeller }
